import '../../HomePage/css/Feedback.css'
import { useState } from 'react';
import { url } from '../../constants/url';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import vulnytics from '../../Assests/buglogo.png'
import { useEffect } from 'react';

function FeedbackForm() {

    const { token } = useParams();

    const [company, setCompany] = useState("");
    const [name, setName] = useState("");
    const [designation, setDesignation] = useState("");
    const [message, setMessage] = useState("");


    const [companyError, setCompanyError] = useState("");
    const [nameError, setNameError] = useState("");
    const [designationError, setDesignationError] = useState("");
    const [messageError, setMessageError] = useState("");

    const [submitted, setSubmitted] = useState(false)
    const [valid, setValid] = useState(null)
    const [formSubmitting, setFormSubmitting] = useState(false)



    const handleSubmit = async () => {
        setFormSubmitting(true)
        const invalidChars = /[^a-zA-Z0-9 .,!?@&()\-\n]/;

        const cleanInput = (value) => value.replace(/<[^>]*>/g, "").replace(invalidChars, "").trim();

        const cleanCompany = cleanInput(company);
        const cleanName = cleanInput(name);
        const cleanDesignation = cleanInput(designation);
        const cleanMessage = cleanInput(message);


        if (cleanCompany === '') {
            setCompanyError("Company name is required");
            return;
        }
        if (cleanName === '') {
            setNameError("Your name is required");
            return;
        }
        if (cleanDesignation === '') {
            setDesignationError("Designation is required");
            return;
        }
        if (cleanMessage === '') {
            setMessageError("Please write a message");
            return;
        }

        if (
            invalidChars.test(company) ||
            invalidChars.test(name) ||
            invalidChars.test(designation) ||
            invalidChars.test(message)
        ) {
            toast.error("Special characters or HTML tags are not allowed.");
            return;
        }
        try {
            const response = await fetch(`${url}/sendfeedback/${token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    company, name, designation, message
                })
            })

            if (response.status === 200) {
                setSubmitted(true)

                setCompany('');
                setName('');
                setDesignation('');
                setMessage('');
                setCompanyError('')
                setNameError('')
                setDesignationError('')
                setMessageError('')
                return
            }

            if (response.status !== 200) {
                setFormSubmitting(false)
                setSubmitted(false)
                toast.error('Link expired or invalid', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }
        } catch (error) {
            setFormSubmitting(false)
            console.log(error)
            setSubmitted(false)
        }
    }

    const handleVerifyFeedbackLink = async () => {
        try {
            const response = await fetch(`${url}/verifyfeedbacklink/${token}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
            })

            if (response.status === 200) {
                setValid(true)
                return
            }

            if (response.status !== 200) {
                setValid(false)
                return
            }


        } catch (error) {
            console.log(error)
            setValid(false)
        }
    }

    useEffect(() => {
        handleVerifyFeedbackLink()
    }, [token])

    return (
        <div className="feedback-container">
            <div className='icon_center'>
                <img src={vulnytics} className='vulnytics-image' />
            </div>

            <h2>Vulnytics Feedback</h2>
            <p>We value your input — drop feedback or suggestions and we'll get back to you.</p>

            {valid === null ? (
                <div>Loading...</div>
            ) :
                valid ? (
                    <>
                        {submitted ? (
                            <div
                                style={{
                                    maxWidth: "500px",
                                    margin: "20px auto",
                                    padding: "20px",
                                    // backgroundColor: "#f0f9ff",
                                    // border: "1px solid #a5d8ff",
                                    borderRadius: "8px",
                                    textAlign: "center",
                                    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                                    color: "#1c7ed6",
                                    fontFamily: "Arial, sans-serif"
                                }}
                            >
                                <h2 style={{ marginBottom: "10px" }}>🎉 Thank You!</h2>
                                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>
                                    We’ve received your feedback successfully. Your input helps us improve our services.
                                </p>
                            </div>
                        ) : (
                            <div className="feedback-grid">
                                <div className="feedback-form">
                                    <div className="form-group">
                                        <label>Company Name</label>
                                        <input
                                            type='text'
                                            value={company}
                                            onChange={(e) => {
                                                setCompany(e.target.value)
                                                setCompanyError('')
                                            }}
                                            placeholder="ACME Corp"
                                        />
                                        {companyError && <p className="error-text" style={{ color: "red", fontSize: "12px" }}>{companyError}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Name</label>
                                        <input
                                            type='text'
                                            value={name}
                                            onChange={(e) => {
                                                setName(e.target.value)
                                                setNameError('')
                                            }}
                                            placeholder="Jane Doe"
                                        />
                                        {nameError && <p className="error-text" style={{ color: "red", fontSize: "12px" }}>{nameError}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Designation</label>
                                        <input type='text'
                                            value={designation}
                                            onChange={(e) => {
                                                setDesignation(e.target.value)
                                                setDesignationError('')
                                            }}

                                            placeholder="Product Manager"
                                        />
                                        {designationError && <p className="error-text" style={{ color: "red", fontSize: "12px" }}>{designationError}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Feedback Message</label>
                                        <textarea
                                            value={message}
                                            onChange={(e) => {
                                                setMessage(e.target.value)
                                                setMessageError('')
                                            }}
                                            rows={5}
                                            placeholder="Tell us what's on your mind"
                                        />
                                        {messageError && <p className="error-text" style={{ color: "red", fontSize: "12px" }}>{messageError}</p>}
                                    </div>

                                    <div className="form-actions">
                                        <button
                                            type="submit"
                                            className="submit-btn"
                                            onClick={handleSubmit}
                                        >
                                            {formSubmitting ? "Submitting..." : "Send Feedback"}
                                        </button>

                                        <button
                                            type="button"
                                            onClick={() => {
                                                setCompany('');
                                                setName('');
                                                setDesignation('');
                                                setMessage('');
                                                setCompanyError('')
                                                setNameError('')
                                                setDesignationError('')
                                                setMessageError('')
                                            }}
                                            className="reset-btn">
                                            Reset
                                        </button>
                                    </div>


                                </div>


                            </div>
                        )}
                    </>
                ) : (
                    <div
                        style={{
                            maxWidth: "500px",
                            margin: "20px auto",
                            padding: "20px",
                            borderRadius: "8px",
                            textAlign: "center",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                            // backgroundColor: "#ffe3e3",
                            color: "#d00000",
                            fontFamily: "Arial, sans-serif"
                        }}
                    >
                        <h2 style={{ marginBottom: "10px", color: 'red', fontSize: "18px", fontWeight: 500 }}>Sorry, the form you have requested does not exist.</h2>
                        <p style={{ fontSize: "16px", lineHeight: "1.5" }}>
                            Make sure that you have the correct URL and the file exists.
                        </p>
                    </div>
                )
            }


        </div>
    );
}

export default FeedbackForm
